import { For, Show, useContext } from 'solid-js';
import { CrossIcon } from '../../../icons-library/cross';
import {
    StyledMenuHeader,
    StyledMenuHeaderLink,
    StyledMenuHeaderLinks,
    StyledMenuHeaderIconLinks,
    StyledCloseButton,
    StyledCloseButtonText,
    StyledMenuHeaderRight,
} from './menu-header.styles';
import type { LinkType, MenuHeaderProps } from '../../menu-header-types';
import urlMatches from '../../../../tools/url-match';
import { removeTrailingSlash } from '../../../../tools/remove-trailing-slash';
import { AppContext } from '../../../../app-context-provider/app-context-provider';
import { HeaderNavigationShortcuts } from '../../../header/header-navigation-shortcuts';
import removeAmpersand from '../../../../tools/remove-ampersand';
import { Link } from '@solidjs/router';
import clsx from 'clsx';

export const MenuHeaderDesktop = (props: MenuHeaderProps) => {
    const { appStore, localize } = useContext(AppContext);
    const { close } = appStore;

    return (
        <StyledMenuHeader>
            <StyledMenuHeaderLinks>
                <Show when={props.showHeaderLinks}>
                    <For each={props.links}>
                        {(link: LinkType) => {
                            const isActive = urlMatches(link.url);

                            return (
                            <Link
                                href={removeTrailingSlash(link.url)}
                                onClick={close}
                                class={clsx(
                                'uppercase text-[1.29rem] leading-[1.93rem] tracking-[0] font-atos-bold font-[800] self-start transition-colors duration-200',
                                isActive
                                    ? 'text-primary underline hover:text-grey-500'
                                    : 'text-gray no-underline hover:text-grey-500'
                                )}
                            >

                                {removeAmpersand(link.title)}
                             </Link>
                        )}  }
                    </For>
                </Show>
            </StyledMenuHeaderLinks>
            <StyledMenuHeaderRight>
                <StyledMenuHeaderIconLinks>
                    <HeaderNavigationShortcuts />
                </StyledMenuHeaderIconLinks>
                <StyledCloseButton 
                    onClick={() => props.handleCloseMenuClick()}
                    aria-label={localize('close', 'Close')}
                >
                    <CrossIcon fill="white" width={1.79} height={1.79} ariaHidden />
                    <StyledCloseButtonText>{localize('close', 'Close')}</StyledCloseButtonText>
                </StyledCloseButton>
            </StyledMenuHeaderRight>
        </StyledMenuHeader>
    );
};
